import { BaseController } from '../../../../common/base/controller';
import _ from 'lodash';

class PartnerListController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  get hasSelected() {
    return !!this.selectedPartner;
  }

  get partners() {
    return this.internalPartners;
  }

  set partners(value) {
    this.internalPartners = value;
    if (this.internalPartners) {
      this.setDetailValues();
    }
  }

  $onInit() {

  }

  togglePartner(partner) {
    partner.stashed = !partner.stashed;
    this.setDetailValues();
  }

  selectPartner(partner) {
    if (this.isSelected(partner)) {
      return this.selectedPartner = null;
    }
    this.selectedPartner = partner;
  }

  deselectPartner() {
    this.selectPartner(null);
  }

  isSelected(partner) {
    return this.selectedPartner === partner;
  }

  savePartner(partner) {
    if (this.selectedPartner.partner) {
      return _.assign(this.selectedPartner.partner, partner);
    }
    this.selectedPartner.partner = partner;
    this.setDetailValues();
  }

  setDetailValues() {
    this.detailValues = {
      incompleteCount: _.filter(this.partners, p => !p.stashed && !p.partner).length,
      stashedCount: _.filter(this.partners, p => p.stashed).length
    };
  }
}

export default PartnerListController;
